import { CriterionService } from './criterion.service'
import { CriterionItem } from './criterion-item'
import { Project } from './project'
import { DbRecord } from './db-record'


export class Criterion {
  private _title: string
  itemsSet = new Set<CriterionItem>()
  valuesMap = new Map<string, number>()
  matchesMap = new Map<string, Set<CriterionItem>>()
  private _isExternal = false;
  private _externalWeights = new Map<string, number>();

  constructor(
    private cs: CriterionService,
    public project: Project,
    public id: string,
    title: string,
    isExternal?: boolean
  ) {
    this.project.criterionsMap.set(this.id, this);
    this._title = title;
    if (isExternal) {
      this._isExternal = true;
    }
  }

  setExternalWeights(weights: [string,number][]) {
    weights.forEach(tpl => {
      this._externalWeights.set(tpl[0], tpl[1]);
    })
  }

  getSortHits(dbr: DbRecord) {
    return this.matchesMap.get(dbr.id) || new Set<CriterionItem>()
  }

  addMatch(dbr: DbRecord, ci: CriterionItem) {
    let s = this.matchesMap.get(dbr.id)
    if (!s) {
      s = new Set<CriterionItem>()
      this.matchesMap.set(dbr.id, s)
    }
    s.add(ci)
  }

  run(dbr: DbRecord, forceRun?: boolean) {
    if (this._isExternal) {
      return this._externalWeights.get(dbr.id) ||  9999999;
    }

    if (!forceRun) {
      let v = this.valuesMap.get(dbr.id);
      if (v != undefined)
        return v;
    }

    let sum = 0;
    this.itemsSet.forEach((ci) => sum += ci.run(dbr));
    sum = -1 * sum;  // -1*: reverse order, highest weight first
    this.valuesMap.set(dbr.id, sum);
    return sum;
  }

  set title(txt) {
    this._title = txt.replace(/\s+/g, ' ').trim();
  }

  get title() {
    return this._title;
  }

  get items() {
    return Array.from(this.itemsSet);
  }
}



// WEBPACK FOOTER //
// /GIT/Search-manager/rating-module/src/app/criterion.ts